import { useEffect, useRef } from 'react';
import gsap from 'gsap';

// Scroll-reveal for a single element. Replaces the ~8 near-identical
// IntersectionObserver + GSAP "AnimatedCard" wrappers scattered across pages.
//
//   const ref = useReveal({ index });     // stagger within a grid
//   return <div ref={ref}>...</div>;
//
// Respects prefers-reduced-motion (shows content immediately, no animation).
export function useReveal({ index = 0, y = 40, scale = 0.95, stagger = 0.08, duration = 0.5 } = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const reduced =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) {
      gsap.set(el, { opacity: 1, y: 0, scale: 1 });
      return undefined;
    }

    gsap.set(el, { opacity: 0, y, scale });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.to(el, {
              opacity: 1,
              y: 0,
              scale: 1,
              duration,
              delay: (index % 4) * stagger,
              ease: 'power3.out',
            });
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [index, y, scale, stagger, duration]);

  return ref;
}
